import React, { useState } from 'react';

const AmountInput = ({inputValue, inputName, onChange, fieldName}) => {
  const [value, setValue] = useState('');
  const [name, setName] = useState('')

  const handleChange = (e) => {
    let input = e.target.value;

    input = input.replace(/[^\d.]/g, '');

    // Allow only one decimal point
    const parts = input.split('.');
    if (parts.length > 2) {
      return; 
    }

    // Format integer part with comma separator
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    setValue(parts.join('.'));
    inputValue = parts.join('.')
    setName(e.target.name)
    inputName = e.target.name
  };

  const handleBlur = () => {
    // setValue((prevValue) => prevValue.replace(/\.$/, ''));
    // onChange(value.replace(/\.$/, ''), name);
    setValue((prevValue) => prevValue);
    onChange(value, name);
    inputValue = value
    inputName = name
  };

  return (
    <div>
      <input
        type="text"
        id="amount"
        value={value}
        name={fieldName}
        onChange={handleChange}
        onKeyUp={handleBlur}
        placeholder="Enter amount"
        className="form-control"
      />
    </div>
  );
};

export default AmountInput;
